import { Grid, Typography } from '@mui/material';
import React from 'react';
import { injectIntl } from 'react-intl';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { getIntegerOrFixed } from '../../../../utils/formatNumber';

const ColoredRatio = props => {
  const { intl, warn, color, value } = props;

  return (
    <Grid container spacing={1} sx={{
      alignItems: "center"
    }}>
      {warn && (
        <Grid>
          <WarningRoundedIcon style={{ color: '#ffa600' }} />
        </Grid>
      )}
      {/* <Grid style={{ flexGrow: 1 }}>
        <Typography color="textSecondary">{intl.formatMessage({ id: 'ratio' })}</Typography>
      </Grid> */}
      <Grid style={{ flexGrow: 1 }}>
        <Typography style={{ color: color, fontWeight: 'bold', fontSize: '160%' }}>
          {value ? `${getIntegerOrFixed(value, 1)}%` : value === 0 ? '0%' : '-'}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default injectIntl(ColoredRatio);
